import usePrismicQuery from 'dpl/prismic/hooks/usePrismicQuery';
import { DOCUMENT_TYPES } from 'dpl/prismic/utils/customPropTypes';

import { getFetchLinks } from '../../utils';

export default function usePrismicHub(uid) {
  const { isSuccess, value } = usePrismicQuery({
    documentType: DOCUMENT_TYPES.HUB,
    uid,
    fetchLinks: getFetchLinks([
      DOCUMENT_TYPES.ARTICLE,
      DOCUMENT_TYPES.HUB,
      DOCUMENT_TYPES.PERSON,
      DOCUMENT_TYPES.NAVIGATION
    ])
  });

  return {
    hub: value,
    isSuccess
  };
}
